module.exports = __webpack_public_path__ + "static/farm-1a441e251366f249a6f508e25e2f1c83.svg";